###
# Миксин используется в Ember-Data адаптерах для полноценной
# поддержки ресурсов, вложенных через links. Может использоваться для URL вида
# /parent_model/:pid/child_model/:id для создания, удаления и изменения записей.
###
module.exports = Em.Mixin.create
  parentType:         null
  parentRelationship: null

  ###
  # Пытается вытащить ссылку для данной модели из ее parent модели
  ###
  extractLinkFromParent: (type, snapshot) ->
    return null unless @parentType and @parentRelationship

    record = snapshot.record

    parent = record._relationships?[ @parentType ]?.members?.list?[0] ||
      record._relationships?[ @parentType ]?.canonicalMembers?.list?[0]

    return null unless parent

    return parent._relationships?[ @parentRelationship ]?.link

  ###
  # Формирует URL для вложенного ресурса
  ###
  buildURL: (type, id, snapshot) ->
    link = @extractLinkFromParent(type, snapshot)

    if link
      parts = [ @urlPrefix(link) ]
      parts.push(id) if id

      return parts.join('/')
    else
      @_super(arguments...)